import { render, staticRenderFns } from "./CommittedTimber.vue?vue&type=template&id=6634e155&"
import script from "./CommittedTimber.vue?vue&type=script&lang=js&"
export * from "./CommittedTimber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports